import { render } from "./PlayerHeader.vue?vue&type=template&id=2692712e&scoped=true&ts=true"
import script from "./PlayerHeader.vue?vue&type=script&lang=ts"
export * from "./PlayerHeader.vue?vue&type=script&lang=ts"

import "./PlayerHeader.vue?vue&type=style&index=0&id=2692712e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2692712e"]])

export default __exports__